import React from "react";
import Typography from "@mui/material/Typography";
import Container  from "@mui/material/Container";
import {LOTES_STATUS} from '../../utils/constant';

const LotInfoRow = ({id, meters, status}) => {
    const className = status === LOTES_STATUS.AVAILABLE ? 'solares-info ':"solares-info text-red";
    const text = status !== LOTES_STATUS.AVAILABLE ? status : `${meters.toLocaleString("en-US")}`;
    return (
        <div>
            <Typography variant='p' className={className}>#{id} - <span>{text}</span></Typography>
        </div>
    );
}
const SolaresInfo = ({data}) => {
    const dataTable1 = data.slice(0, 14);
    const dataTable2 = data.slice(14, 28);
    const dataTable3 = data.slice(28, 41);

    return (
        <div className="solares-info-section">
            <Typography variant="h3" sx={{color: "var(--primary-color)", fontSize: '30px', fontWeight: 'bold', marginY: '40px'}} className='section-title'>Solares:</Typography>

            <Container className='lotes-tables' sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                <div className="solares">
                    {dataTable1.map((solar) => (
                        <LotInfoRow {...solar} key={solar.id} />
                    ))}
                </div>
                <div className="solares">
                    {dataTable2.map((solar) => (
                        <LotInfoRow {...solar} key={solar.id} />
                    ))}
                </div>
                <div className="solares">
                    {dataTable3.map((solar) => (
                        <LotInfoRow {...solar} key={solar.id}/>
                    ))}
                </div>
            </Container>
        </div>
    );
}

export default SolaresInfo;
